import type { PublishedUnitSummary, PublicPropertySummary } from '@/lib/types/publicProperty';
import { formatAvailabilityDateLabel, formatPropertyAddress } from '@/lib/utils/propertyFormatting';

export function isAllianceGroup(property: PublicPropertySummary): boolean {
  const address = formatPropertyAddress(property.address).toLowerCase();
  const code = property.propertyCode.toLowerCase();
  return address.includes('501 alliance') || code.includes('alliance') || code.includes('501');
}

export function formatUnitAvailabilityLabel(
  unit: PublishedUnitSummary,
  labels?: { immediateLabel: string; negotiableLabel: string },
): string {
  const availabilityDate = formatAvailabilityDateLabel(unit.availabilityStart);
  if (availabilityDate) {
    return availabilityDate;
  }
  const immediateLabel = labels?.immediateLabel ?? '';
  const negotiableLabel = labels?.negotiableLabel ?? '';
  const immediate = immediateLabel.trim().length > 0 ? immediateLabel : 'Immediate';
  const negotiable = negotiableLabel.trim().length > 0 ? negotiableLabel : 'Negotiable';
  if (unit.possessionTimeline === 'negotiable') {
    return negotiable;
  }
  return immediate;
}

export function unitHasIncentives(unit: PublishedUnitSummary): boolean {
  return typeof unit.incentives === 'string' && unit.incentives.trim().length > 0;
}
